const inViewOnce = (element, animations, options = { margin: `0px 0px -${window.innerHeight * 0.5}px 0px` }) => {
  const { inView, animate } = window.Motion;

  const stop = inView(
    element,
    (ev) => {
      animations.forEach((animation) => {
        animate(animation.element, animation.animation, animation?.ease ?? { ease: 'easeOut', duration: 0.5 });
      });
      stop();
    },
    options
  );
};

window.inViewOnce = inViewOnce;
